// Usersnap #2757: static field label rendered ABOVE the input border.
// Replaces MUI floating labels in the Documents modals; the global `legend` reset
// (tailwindcss.scss / pricing-table.scss) breaks the outlined-input notch and made
// the floating label overlap the field border.

import React from 'react';
import { Typography } from '@mui/material';

interface DocFieldLabelProps {
  htmlFor?: string;
  id?: string;
  children: React.ReactNode;
}

export const DocFieldLabel: React.FC<DocFieldLabelProps> = ({ htmlFor, id, children }) => (
  <Typography
    component="label"
    htmlFor={htmlFor}
    id={id}
    sx={{
      display: 'block',
      mb: 1, // 8px gap between label and field
      fontSize: 15,
      fontWeight: 600,
      lineHeight: 1.4,
      color: 'text.primary',
    }}
  >
    {children}
  </Typography>
);

// Shared look for the fields under a DocFieldLabel: same height for TextField and Select.
export const docFieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: 15, minHeight: 44 },
  // No floating label: hide the empty notch legend (the global `legend` reset gives it
  // height) and let the border start at the top edge, so nothing pushes the text down.
  '& .MuiOutlinedInput-notchedOutline': { top: 0 },
  '& .MuiOutlinedInput-notchedOutline legend': { display: 'none' },
  // Equal top/bottom padding keeps the value vertically centered in the 44px box.
  '& .MuiOutlinedInput-input, & .MuiSelect-select': {
    padding: '10px 14px',
    lineHeight: '24px',
    height: 'auto',
    minHeight: 0,
    boxSizing: 'border-box',
  },
  '& .MuiSelect-select': { display: 'flex', alignItems: 'center', pr: '32px !important' },
} as const;
